import { useRef } from 'react';
import { useSelector } from "react-redux";
import 'chart.js/auto';
import { Chart, getDatasetAtEvent, getElementAtEvent } from 'react-chartjs-2';

export default function({showExclusion, filtered}) {
    const mainOverview = useSelector((state) => state.projects)
    const filteredOverview = mainOverview.filteredOverview
    const overview = !filtered ? mainOverview : filteredOverview
    const { projectsUsage, exclusionUsage }  = overview
    const chartRef = useRef()
    const projectsDatesCount = projectsUsage.sortedDates.length
    const exclusionsDatesCount = exclusionUsage.sortedDates.length
    const projectsStep = 1// Math.ceil(projectsDatesCount/5)
    const exclusionsStep = 1// Math.ceil(exclusionsDatesCount/5)
    const projectsData = projectsUsage.sortedDates.map((date, i) =>{ if (i % projectsStep != 0 && i < projectsDatesCount-1) return null;  return projectsUsage.dates[date].totalProjects }).filter(entry=>entry)
    const scansData = projectsUsage.sortedDates.map((date, i) =>{ if (i % projectsStep != 0 && i < projectsDatesCount-1) return null;  return projectsUsage.dates[date].totalScans }).filter(entry=>entry)
    const exclusionsData = exclusionUsage.sortedDates.map((date, i) => {if (i % exclusionsStep != 0 && i < exclusionsDatesCount-1) return null; return exclusionUsage.dates[date].totalExclusions}).filter(entry=>entry)
    const projectsLabel = projectsData.map(() => "")
    const exclusionLabel = exclusionsData.map(() => "")
    const projectsDatasets = [
        {
            label: "Analyses",
            data: scansData,
            borderColor: window.getColor("high-half"),
            backgroundColor: window.getColor("high-half"),
        },
        {
            label: "Projects",
            data: projectsData,
            borderColor: window.getColor("low-half"),
            backgroundColor: window.getColor("low-half"),
        },
    ]
    const exclusionDatasets = [
        {
            label: "Exclusions",
            data: exclusionsData,
            borderColor: window.getColor("low-half"),
            backgroundColor: window.getColor("low-half"),
        }
    ]
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        onHover: (event, chart) => {
            // setCurserPointerOnHover(event, chart.length)

        },
        resizeDelay: false,
        scales: {
           x: {
            border: {
                display: false
            },
            grid: {
                lineWidth: 0
            },
            
            
           },
           y: {
            ticks: {
                stepSize: 25
            },
            border: {
                display: false
            },
            title: {
                display: false,
                text: "Analyses + Projects",
                padding: 0
            },
            beginAtZero: true
           }
        },
        plugins: {
           legend: {
                display: false
            }, 
            decimation:{
                enabled: true,
                algorithm: "min-max",
                samples: 10
            }
        },
        elements: {
            point: {
                radius: .5
            }
        }
    }
    const setCurserPointerOnHover = (event, isOnhover) => {
        if(isOnhover) {
            event.native.target.style.cursor = "pointer"

        } else {
            event.native.target.style.cursor = "default"
        }
    }
    const chartData = {
        labels: showExclusion ? exclusionLabel: projectsLabel,
        datasets: showExclusion ? exclusionDatasets: projectsDatasets
    }
    return <Chart ref={chartRef} type='line' data={chartData} options={options} />
}

